import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const MediaViewerDialog = ({
  open,
  onClose,
  currentImages,
  currentImageIndex,
  handlePreviousImage,
  handleNextImage,
  maker,
  checker,
  aiComments,
  checkerComments,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogActions>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogActions>

      <DialogContent style={{ textAlign: "center" }}>
        {/* Additional Details - Placed Above the Image */}
        {(maker || checker || aiComments || checkerComments) && (
          <div style={{ marginBottom: "10px" }}>
            {maker && (
              <Typography variant="body1">
                <strong>Maker:</strong> {maker}
              </Typography>
            )}
            {checker && (
              <Typography variant="body1">
                <strong>Checker:</strong> {checker}
              </Typography>
            )}
            {aiComments && (
              <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
                <strong>AI Comments:</strong>
                {"\n"}
                {aiComments}
              </Typography>
            )}

            {checkerComments && (
              <Typography variant="body1">
                <strong>Checker Comments:</strong> {checkerComments}
              </Typography>
            )}
            <Divider style={{ margin: "10px 0" }} />
          </div>
        )}

        {/* Display image or video */}
        {currentImages.length > 0 ? (
          <>
            {/\.(mp4|avi|mov)$/i.test(currentImages[currentImageIndex]) ? (
              <video
                controls
                style={{
                  maxWidth: "100%",
                  maxHeight: "60vh",
                  borderRadius: "8px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              >
                <source
                  src={currentImages[currentImageIndex]}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={currentImages[currentImageIndex]}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "60vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                }}
              />
            )}
            {/* Image Counter */}
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginTop: "8px" }}
            >
              {currentImageIndex + 1} of {currentImages.length}
            </Typography>
          </>
        ) : (
          <Typography>No Media Available</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <IconButton
          onClick={handlePreviousImage}
          disabled={currentImageIndex === 0}
        >
          <ArrowBackIcon />
        </IconButton>
        <IconButton
          onClick={handleNextImage}
          disabled={currentImageIndex === currentImages.length - 1}
        >
          <ArrowForwardIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
};

export default MediaViewerDialog;
